/**
 * JWT Decode Utility
 *
 * Simple JWT payload decoder for client-side use.
 * Does NOT verify the signature - only extracts the payload.
 */

export function jwtDecode(token: string): unknown {
  try {
    const parts = token.split(".") as [string, string, string];
    if (parts.length !== 3) throw new Error("Invalid JWT format");

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Invalid JWT", e);
    return null;
  }
}
